// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-option--container[data-v-150750f4] {\n  height: 300px;\n}\n.setting-subtitle[data-v-150750f4] {\n  color: #B8B8B8;\n  font-size: 16px;\n}\n.element-upload[data-v-150750f4] {\n  height: 100%;\n  width: 300px;\n  background: #C4C4C4;\n}\n.upload-label[data-v-150750f4] {\n  margin: 6px 0 0;\n  cursor: pointer;\n  font-size: 12px;\n}\n.upload-input[data-v-150750f4] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
